import React from 'react';
import ReactDOM from 'react-dom';
// import './assets/css/style.css';
import App from './App';
import registerServiceWorker from './registerServiceWorker';

import { createStore , applyMiddleware ,compose} from 'redux';
import {Provider} from 'react-redux';
import allreducers from './Reducers/';
import thunk from 'redux-thunk';
import config from './config/env';
import logger from 'redux-logger'
// if(config.env === 'production'){
    // console.log =()=>{};
// }

// let store=createStore(allreducers,compose(applyMiddleware(thunk), window.devToolsExtension && window.devToolsExtension()) );
let store=createStore(allreducers,compose(applyMiddleware(thunk)) );


ReactDOM.render(<Provider store={store}><App /></Provider>, document.getElementById('root'));
//registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js